export const TOTAL_WORDS =
  "til\\s?sammen|totalt|i alt|samlet|summerer(?:\\s+seg)?\\s+til|summen\\s+(?:blir|er)(?:\\s+på)?|en sum på";
export const PERCENT = "(\\d+(?:[.,]\\d+)?)\\s*(?:%|prosent)";
const STATED_TOTAL = new RegExp(`(?<![\\p{L}])(?:${TOTAL_WORDS})\\s*[:=]?\\s*(?:på\\s+)?${PERCENT}`, "giu");
const SENTENCE_END = /(?<=[.!?])\s+/u;

export type CardWeights = { total: number; parts: readonly number[] };

export const percentValue = (digits: string): number => Number(digits.replace(",", "."));

export const sameNumber = (a: number, b: number): boolean => Math.abs(a - b) < 0.0005;

const FULL_WEIGHT = 100;

const isPartOf = (card: CardWeights, stated: number): boolean => card.parts.some((part) => sameNumber(stated, part));

export const statedTotals = (text: string): number[] =>
  [...text.matchAll(STATED_TOTAL)].map((match) => percentValue(match[1]));

export const otherTotals = (text: string | null, card: CardWeights): number[] =>
  text
    ? statedTotals(text).filter(
        (stated) => !sameNumber(stated, card.total) && !(isPartOf(card, stated) && !sameNumber(stated, FULL_WEIGHT)),
      )
    : [];

export const statesOtherTotal = (text: string | null, card: CardWeights): boolean => otherTotals(text, card).length > 0;

export const withoutOtherTotals = (text: string, card: CardWeights): string =>
  text
    .split("\n")
    .map((line) => {
      if (!statesOtherTotal(line, card)) return line;
      const kept = line.split(SENTENCE_END).filter((sentence) => !statesOtherTotal(sentence, card));
      return kept.length > 0 ? kept.join(" ") : null;
    })
    .filter((line): line is string => line !== null)
    .join("\n")
    .trim();
